/*---------------------------------------------------------*\
 * Imports
 \*---------------------------------------------------------*/
import angular from 'angular';
import PubSub from 'pubsub-js';
import _ from 'lodash';

const deps = {};

/*---------------------------------------------------------*\
 * Weakmaps
 \*---------------------------------------------------------*/
const TIMEOUT = new WeakMap();
const NAVIGATION = new WeakMap();

/*---------------------------------------------------------*\
 * CameraList
\*---------------------------------------------------------*/
class CameraListController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor(trafficService, topics, $timeout, localService, storageKeys, navigationService) {
    TIMEOUT.set(this, $timeout);
    deps.trafficService = trafficService;
    deps.localService = localService;
    deps.$timeout = $timeout;
    deps.topics = topics;
    const region = _.isUndefined(this.subRegion) ? deps.localService.get(storageKeys.selectedRegion) : this.subRegion;
    this.name = 'cameraList';
    this.total = 0;
    this.totalSub = 0;
    this.clicklistindex = 0;
    this.clicklistindexSub = 0;
    NAVIGATION.set(this, navigationService);
    this.showCameras = true;
    this.showCamerasSub = false;
    this.showCamerasPhotos = false;
    this.camerasArray = [];
    this.camerasArraySub = [];

    //---------------------------------
    // Get Cameras
    //---------------------------------
    this.loading = true;
    this.items = [{
      label: 'Loading...'
    }];
    this.itemsSub = [{
      label: 'Loading...'
    }];
    trafficService.getTrafficCameras(region.abbr).then(this.applyCameras.bind(this));

    //---------------------------------
    // List Event Handlers
    //
    // Note: placed here so we do not have to bind to this
    //---------------------------------
    this.onListPrevComponent = (index, up) => {
      if (up) {
        PubSub.publish(topics.nav.up, 'camera-list');
      } else {
        PubSub.publish(topics.nav.left, 'camera-list');
      }
    };

    this.onListItemClick = () => {
      this.itemsSub = this.camerasArray[this.clicklistindex].cameras;
      this.applyCamerasSub(this.itemsSub);
      this.showCameras = false;
      this.showCamerasSub = true;
      this.showCamerasPhotos = false;
    };

    this.onListItemClickSub = () => {
      this.showCameras = false;
      this.showCamerasSub = false;
      this.showCamerasPhotos = true;
      this.cameras = this.camerasArraySub;
      this.cameras.index = this.clicklistindexSub;
      this.cameras.showCamerasPhotos = true;
      PubSub.publish(topics.component.selectPhotos, this.cameras);
    };

    this.onListChange = (event) => {
      this.clicklistindex = event.list.selectedIndex;
      this.total = event.list.items.length;
    };

    this.onListChangeSub = (event) => {
      this.clicklistindexSub = event.list.selectedIndex;
      this.totalSub = event.list.items.length;
    };
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  /**
   * This method takes the raw images JSON from the service and converts it into
   * an array that makes sense for our list component on the page.
   *
   * @param items
   */
  applyCameras(item) {
    const feed = item.data.Region.Subregions;

    const groups = _.groupBy(feed.Subregion, subgroup => subgroup.SubregionType.name);

    for (const key in groups) {
      if ({}.hasOwnProperty.call(groups, key)) {
        this.camerasArray.push({
          label: key,
          cameras: !angular.isArray(groups[key][0].SubregionType.Cameras.Camera) ?
            [groups[key][0].SubregionType.Cameras.Camera] :
            groups[key][0].SubregionType.Cameras.Camera
        });
      }
    }
    deps.$timeout(() => {
      this.items = this.camerasArray;
      this.loading = false;
      NAVIGATION.get(this).focusElAsync('.main-content');
    });
  }

  applyCamerasSub(item) {
    const feed = item;
    const groups = _.groupBy(feed, subgroup => subgroup.CameraName);

    for (const key in groups) {
      if ({}.hasOwnProperty.call(groups, key)) {
        this.camerasArraySub.push({
          labelSub: key,
          CameraURL: groups[key][0].CameraURL,
          logo: groups[key][0].logo
        });
      }
    }
    deps.$timeout(() => {
      this.itemsSub = this.camerasArraySub;
      this.loading = false;
      NAVIGATION.get(this).focusElAsync('.main-content #showCamerasSub');
    });
  }

  goBack() {
    NAVIGATION.get(this).focusElAsync('.main-content');
  }
}

CameraListController.$inject = [
  'trafficService',
  'topics',
  '$timeout',
  'localService',
  'storageKeys',
  'navigationService'
];

export default CameraListController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/cameraList/cameraList.controller.js
 **/